<template>
    <div>

        <input ref="FileInput" :accept="accept" :multiple="multiple" style="display: none;" type="file"
               @change="filesChanged($event)">
        <Button :label="multiple ? 'Добавить файлы' : 'Добавить файл'" class="p-button-outlined mb-2"
                @click="$refs.FileInput.click()"/>

        <div v-for="($item, $index) in filesSelected" :key="$index" class="mt-1">

            <InputText v-if="addDescriptionInputs" v-model="$item.description" @change="filesChanged"/>

            <Button :icon="icon" :label="$item.name+ ' (' + bytesToHumanPresent($item.size) + ')'" class="p-button-text"
                    icon-pos="left" @click="$emit('fileClick', $item)"/>

            <Button class="p-button-text" icon="pi pi-times" @click="removeFile($index)"/>

        </div>

    </div>
</template>

<script>

import DataFilters from "../../utils/DataFilters";

export default {

    name: "FilesInput",
    mixins: [DataFilters],
    props: {
        modelValue: null,
        multiple: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: '',
        },
        icon: {
            default: 'pi pi-eye',
            type: String
        },
        addDescriptionInputs: Boolean,

    },

    emits: ['fileChange', 'value', 'update:modelValue', 'fileClick'],
    data() {
        return {

            filesSelected: Array | FileList | DataTransfer,

        }
    },
    methods: {

        filesChanged($event) {
            this.filesSelected = this.$refs.FileInput.files;
            this.$emit('fileChange', this.filesSelected);
            this.$emit('update:modelValue', this.filesSelected);
        },

        removeFile($index) {

            const dt = new DataTransfer()
            const input = this.$refs.FileInput
            const {files} = input

            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                if ($index !== i)
                    dt.items.add(file)
            }

            input.files = dt.files
            this.filesSelected = input.files;


            this.$emit('fileChange', this.filesSelected);
            this.$emit('update:modelValue', this.filesSelected);
        }

    },
    watch: {

        modelValue(newVal) {

            if (newVal) {

                let dt = new DataTransfer

                if (newVal instanceof DataTransfer || newVal instanceof FileList) {

                    dt = newVal


                } else {

                    for (const file of newVal)
                        dt.items.add(file)

                }

                this.$refs.FileInput.files = dt.files
                this.filesSelected = this.$refs.FileInput.files

            }

        }

    },

}
</script>

<style scoped>

</style>